module.exports = __webpack_public_path__ + "static/media/Lam-min.a66ea6e3.PNG";